import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import RestrictedMarkdown from './RestrictedMarkdown';
import CitationsPanel from './CitationsPanel';
import DemoBanner from './DemoBanner';

export const AI_NOTICE_TEXT = 'AI-generated, verify before applying';

// Display-only rendering of a contract IssueInsight. Callers own the ai_assistant gating, so
// this card adds no AI surface of its own; the notice is the OWASP LLM09 "verify" control.
export default function IssueInsightCard({ insight }) {
  if (!insight || typeof insight !== 'object' || typeof insight.summary !== 'string') return null;

  const hasFix = typeof insight.possibleFix === 'string' && insight.possibleFix.length > 0;

  return (
    <Paper variant="outlined" data-testid="ai-issue-insight-card" className="ai-issue-insight-card" sx={{ p: 1.5 }}>
      <DemoBanner />
      <Typography variant="caption" component="div" data-testid="ai-insight-notice">{AI_NOTICE_TEXT}</Typography>
      <Box data-testid="ai-insight-summary">
        <RestrictedMarkdown content={insight.summary} />
      </Box>
      {hasFix && (
        <Box data-testid="ai-insight-fix">
          <RestrictedMarkdown content={insight.possibleFix} />
        </Box>
      )}
      <CitationsPanel citations={insight.citations} />
    </Paper>
  );
}
